<template>
  <b-modal
    v-model="isOpen"
    size="md"
    :title="$t('publish_mission.save_draft_modal.title')"
    no-footer
    data-e2e="save-draft-modal"
  >
    <div class="px-6 pb-6">
      <!-- Icon -->
      <div class="flex justify-center mb-6">
        <div class="size-16 rounded-full bg-gray-700 flex items-center justify-center">
          <Icon name="solar:diskette-linear" class="size-8 text-primary" />
        </div>
      </div>

      <!-- Message -->
      <p class="text-center text-gray-300 mb-8">
        {{ $t('publish_mission.save_draft_modal.message') }}
      </p>

      <!-- Actions -->
      <div class="flex flex-col gap-3">
        <b-button
          @click="onSave"
          block
          data-e2e="save-draft-confirm"
        >
          {{ $t('publish_mission.save_draft_modal.save_button') }}
        </b-button>

        <b-button
          variant="tertiary"
          @click="onDiscard"
          block
          data-e2e="save-draft-discard"
        >
          {{ $t('publish_mission.save_draft_modal.discard_button') }}
        </b-button>

        <button
          type="button"
          class="text-gray-400 hover:text-white text-sm transition-colors mt-2"
          @click="onCancel"
          data-e2e="save-draft-cancel"
        >
          {{ $t('common.cancel') }}
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script setup lang="ts">
import BModal from '~/components/modal/BModal.vue';
import BButton from '~/components/forms/BButton.vue';

const isOpen = defineModel<boolean>({ default: false });

const emit = defineEmits(['save', 'discard']);

const onSave = () => {
  emit('save');
  isOpen.value = false;
};

const onDiscard = () => {
  emit('discard');
  isOpen.value = false;
};

const onCancel = () => {
  isOpen.value = false;
};
</script>
